import { Observable } from 'rxjs';

// If a key is added here, an equivalent key must be added to the translation file
export enum ErrorKey {
  inactiveUser = 'inactiveUser',
  networkError = 'network',
  neighbourhood = 'neighbourhood',
  lead = 'lead',
  cms = 'cms',
};

// {"statusCode":401,"errorCode":41010,"errorMessage":"IDP_INVALID_REFRESH_TOKEN","message":"Refresh token invalid","requestId":"b2b0622a4593490c980ba6bf0001ec02"}
export interface DisplayError {
  msgKey: string;
  code?: number;
}

export abstract class ErrorService {
  abstract readonly allErrors: Observable<DisplayError[]>;
  abstract clearError(errorKey: ErrorKey, emit?: boolean): void;
  abstract clearAllErrors(): void;
  abstract displayError(errorKey: ErrorKey, code?: number, secondsToDisplay?: number): void;
}
